(function () {
  const blockedTitles = new Set(['test #1']);
  const blockedUrlParts = ['/blogs/news/test', '/products/test'];
  const searchContainerSelector = [
    'predictive-search',
    '[data-predictive-search]',
    '.predictive-search',
    '.snize-ac-results',
    '.snize-ac-results-content',
    '.snize-ac-results-columns',
    '.snize-ac-results-list',
    '.snize-ac-results-pages',
    '.snize-autocomplete',
    '.snize-search-results',
    '#snize-search-results',
    '#snize_results',
    '[class*="snize-ac"]',
    '[id*="snize-ac"]',
  ].join(',');
  const searchItemSelector = [
    '.predictive-search__list-item',
    '.snize-ac-result',
    '.snize-ac-results-product',
    '.snize-ac-results-product-item',
    '.snize-ac-results-page',
    '.snize-ac-results-item',
    '.snize-product',
    '.snize-product-item',
    '.snize-search-results-item',
    '.snize-suggestion',
    '[role="option"]',
    'li',
  ].join(',');

  function normalizeText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function getHrefs(element) {
    const hrefs = [];
    const ownHref = element.getAttribute?.('href');

    if (ownHref) {
      hrefs.push(ownHref);
    }

    element.querySelectorAll?.('a[href]').forEach((link) => hrefs.push(link.getAttribute('href')));

    return hrefs;
  }

  function isBlockedResult(element) {
    const text = normalizeText(element.textContent);
    const hrefs = getHrefs(element);

    return blockedTitles.has(text) || hrefs.some((href) => blockedUrlParts.some((urlPart) => href.includes(urlPart)));
  }

  function hideElement(element) {
    if (!element) {
      return;
    }

    element.hidden = true;
    element.setAttribute('aria-hidden', 'true');
    element.style.setProperty('display', 'none', 'important');
  }

  function hideEmptyPageSections(container) {
    container.querySelectorAll('.snize-ac-results-pages, .predictive-search__pages-wrapper').forEach((section) => {
      const visibleLinks = Array.from(section.querySelectorAll('a[href], [role="option"]')).filter(
        (item) => item.offsetParent !== null && !item.hidden
      );

      if (visibleLinks.length === 0) {
        hideElement(section);
      }
    });
  }

  function getSearchContainers(root) {
    const containers = new Set();

    if (root instanceof Element) {
      if (root.matches(searchContainerSelector)) {
        containers.add(root);
      }

      const closestContainer = root.closest(searchContainerSelector);
      if (closestContainer) {
        containers.add(closestContainer);
      }
    }

    if (root.querySelectorAll) {
      root.querySelectorAll(searchContainerSelector).forEach((container) => containers.add(container));
    }

    return containers;
  }

  function hideBlockedSearchSuggestions(root = document) {
    getSearchContainers(root).forEach((container) => {
      container.querySelectorAll(searchItemSelector).forEach((item) => {
        if (isBlockedResult(item)) {
          hideElement(item);
        }
      });

      container.querySelectorAll('a[href]').forEach((link) => {
        if (isBlockedResult(link)) {
          hideElement(link.closest(searchItemSelector) || link);
        }
      });

      hideEmptyPageSections(container);
    });
  }

  function observeSearchSuggestions() {
    hideBlockedSearchSuggestions();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) {
            hideBlockedSearchSuggestions(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeSearchSuggestions);
  } else {
    observeSearchSuggestions();
  }
})();
